/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for Azure AD admin consent URL retrieval
 * @export
 * @interface ConsentUrlResponse
 */
export interface ConsentUrlResponse {
    /**
     * Whether the consent URL was successfully generated
     * @type {boolean}
     * @memberof ConsentUrlResponse
     */
    success?: boolean;
    /**
     * Azure AD admin consent URL (if successful)
     * @type {string}
     * @memberof ConsentUrlResponse
     */
    consentUrl?: string;
    /**
     * Error message if consent URL generation failed
     * @type {string}
     * @memberof ConsentUrlResponse
     */
    error?: string;
    /**
     * Detailed error information about what conditions were not met
     * @type {string}
     * @memberof ConsentUrlResponse
     */
    errorDetails?: string;
}

/**
 * Check if a given object implements the ConsentUrlResponse interface.
 */
export function instanceOfConsentUrlResponse(value: object): value is ConsentUrlResponse {
    return true;
}

export function ConsentUrlResponseFromJSON(json: any): ConsentUrlResponse {
    return ConsentUrlResponseFromJSONTyped(json, false);
}

export function ConsentUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsentUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'consentUrl': json['consentUrl'] == null ? undefined : json['consentUrl'],
        'error': json['error'] == null ? undefined : json['error'],
        'errorDetails': json['errorDetails'] == null ? undefined : json['errorDetails'],
    };
}

export function ConsentUrlResponseToJSON(json: any): ConsentUrlResponse {
    return ConsentUrlResponseToJSONTyped(json, false);
}

export function ConsentUrlResponseToJSONTyped(value?: ConsentUrlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'consentUrl': value['consentUrl'],
        'error': value['error'],
        'errorDetails': value['errorDetails'],
    };
}

